import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
  adminLevel = false;
  isLogin = false;
  level = '';
  userName = ''
  private authListenerSubs: Subscription;
  constructor(private userService: UserService) { }

  ngOnInit() {
    this.isLogin = this.userService.getIsAuth();
    this.level = this.userService.getUserLevel();
    this.userName = this.userService.getUserName();
    if(this.level == '1') {
      this.adminLevel = true;
    }
    else {
      this.adminLevel = false;
    }

    this.authListenerSubs = this.userService
    .getAuthStatusListner()
    .subscribe((IsAuthenticated) => {
        this.isLogin = IsAuthenticated;
        this.level = this.userService.getUserLevel();
        this.userName = this.userService.getUserName();
        if(this.level == '1') {
           this.adminLevel = true;
        }
        else {
           this.adminLevel = false;
        }  
    });
  }

  onLogout() {
    this.userService.logout();
  }

  ngOnDestroy() {
    this.authListenerSubs.unsubscribe();  
  }
}